<label>
    <input type="checkbox" [formControl]="control">
    <div class="box"></div>
    <div class="content">
        <ng-content></ng-content>
    </div>
</label>